import React from 'react';
import Link from 'components/misc/Link';
import { Group } from 'entity/group/groupRedux';
import GroupPassport from '../GroupPassport';
import JoinGroupButton from '../JoinGroupButton';

interface OwnProps {
  groupList: Group[];
  empty?: React.ReactNode;
}

const JoinGroupList = (props: OwnProps) => {
  const { groupList = [], empty } = props;

  const dataSource = groupList.map(group => {
    const {
      id,
      name,
      slug,
      profileImage,
      discussionsCount,
      followedByCurrentUser,
      isToggling,
    } = group;
    return (
      <div className="flex items-center justify-between w-full" key={id}>
        <Link as={`/community/${slug}`} href={`/community/${slug}`}>
          <a>
            <GroupPassport
              name={name}
              image={profileImage}
              discussionsCount={discussionsCount}
            />
          </a>
        </Link>
        {slug !== 'announcements' && (
          <JoinGroupButton
            followedByCurrentUser={followedByCurrentUser}
            isLoading={isToggling}
            id={id}
          />
        )}
      </div>
    );
  });

  return (
    <div className="flex flex-col w-full gap-4 items-center;">
      {dataSource.length === 0 ? empty : dataSource}
    </div>
  );
};

export default JoinGroupList;
